<template>
  <div>
    <c-input
      file
      v-if="$isEmpty(pathFiles)"
      prepend-icon
      prepend-inner-icon="$file"
      v-model="file"
      @change="upload"
      :label="label"
      show-size
      :accept="accept"
      v-bind="$attrs"
      :loading="progressing"
      :disabled="progressing"
      :multiple="multiple"
    />

    <div v-else>
      <div class="font-90 mb-4">{{ label }}</div>
      <div class="d-inline-flex">
        <v-card v-for="path in pathFiles" :key="path" class="d-inline-block me-2" elevation="2">
          <a :href="url(path)" target="_blank" class="d-inline-block pa-1" style="line-height: 0px">
            <img v-if="isImage(path)" alt="image" :src="url(path)" width="65" height="65" />

            <video v-else-if="isVideo(path)" width="65" height="65">
              <source :src="url(path)" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <div v-else>{{ getExtension(path) }}</div>
          </a>

          <v-icon
            color="error"
            class="white rounded elevation-1"
            @click.stop="removeItem(path)"
            small
            :style="{position: 'absolute', top: '5px', left: '5px'}"
          >
            mdi-close
          </v-icon>
        </v-card>

        <label v-if="multiple" for="file" class="mb-0 cursor-pointer">
          <v-card
            class="d-inline-block me-2 h-100 d-flex align-center justify-center"
            width="70"
            elevation="2"
          >
            <v-icon color="success" size="34"> mdi-cloud-upload </v-icon>
          </v-card>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'Uploader',
  props: {
    value: {type: String, default: null},
    multiple: Boolean,
    label: String,
    accept: {type: String, default: '.jpeg,.jpg,.png,.gif'}
  },
  data() {
    return {
      progressing: false,
      file: null,
      pathFiles: []
    }
  },
  watch: {
    value: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  computed: {
    isEmpty() {
      return !(this.pathFiles && this.pathFiles.length)
    }
  },
  methods: {
    isImage(file) {
      const imageExtensions = new Set(['jpeg', 'jpg', 'png', 'gif'])
      return imageExtensions.has(this.getExtension(file))
    },
    isVideo(file) {
      const videoExtensions = new Set(['mp4', 'ogg', 'webm'])
      return videoExtensions.has(this.getExtension(file))
    },
    getExtension(file) {
      return file.split('.').pop()
    },
    init() {
      if (this.value) {
        this.pathFiles = this.value.split(',')
      } else {
        this.pathFiles = []
      }
    },
    url(path) {
      return `${this.$config.shared.staticServerUrl}/${path}`
    },
    removeItem(path) {
      this.pathFiles = this.pathFiles.filter((item) => item !== path)
      this.emitInput()
    },
    upload(files) {
      this.progressing = true
      if (!this.$isEmpty(files)) {
        if (!Array.isArray(files)) {
          files = [files]
        }
        const model = new FormData()
        files.forEach((file) => {
          model.append('files', file)
        })

        return this.$api.files
          .upload(model)
          .then((res) => {
            this.pathFiles.push(...res)
            this.file = null
            this.emitInput()
          })
          .catch((err) => {
            this.$showError(err)
          })
          .finally(() => {
            this.progressing = false
          })
      }
    },
    emitInput() {
      const val = this.pathFiles.join(',')
      this.$emit('input', val)
    }
  }
}
</script>
